module.exports = __webpack_public_path__ + "img/hr.fb8c099a.jpg";